const productCanvas = document.querySelector(".product-canvas");
const cartForm = document.querySelector(".product-form");
const selectWraps = document.getElementsByClassName("product-options-select");


  // Function to reload the Payflex widget with the new price
  function reloadPayflexWidget(newPrice) {
    // Update the widget container to clear existing content
    const widgetContainer = document.getElementById('payflex-widget-container');
    widgetContainer.innerHTML = ''; // Clear the current content
  
    // Create the script tag with the updated price
    const script = document.createElement('script');
    script.src = `https://widgets.payflex.co.za/partpay-widget-0.1.2.js?type=calculator&min=10&max=999999&amount=${newPrice}`;
    script.async = true;
    script.type = "application/javascript";
  
    // Append the new script to load the widget
    widgetContainer.appendChild(script);
  }

for (let i = 0; i < selectWraps.length; i++) {
  const selElmnt = selectWraps[i].getElementsByTagName("select")[0];
  let optionsArray = selElmnt.options;

  /* Create a new DIV to act as the selected item: */
  const newDiv = document.createElement("DIV");
  newDiv.setAttribute("class", "select-selected");
  if (selElmnt.id === "engraving_font") {
    newDiv.innerHTML = `<input type="text" class="input engraving-input" style="font-family: 'Caramel';font-size: 1.2em;" name="properties[Engraving Text]" spellcheck="false" autocapitalize="off" placeholder="Enter Engraving Text" style="margin-bottom: 10px;">`;
    const hiddenDiv = document.createElement("DIV");
    hiddenDiv.innerHTML = `<input type="hidden" class="input engraving-input-hidden" name="properties[Engraving Text]">`;
    newDiv.addEventListener("change", (e) => {
      document.querySelector(".engraving-input-hidden").value = e.target.value;
    });
    cartForm.appendChild(hiddenDiv);
  } else {
    newDiv.innerHTML = optionsArray[selElmnt.selectedIndex].innerHTML;
  }

  // Set event listener on ring size and engraving font
  if (selElmnt.id === "ring_size") {
    const hiddenDiv = document.createElement("DIV");
    hiddenDiv.innerHTML = `<input type="hidden" class="input ring-size-hidden" name="properties[Ring Size]">`;
    cartForm.appendChild(hiddenDiv);
  }
  if (selElmnt.id === "engraving_font") {
    const hiddenDiv = document.createElement("DIV");
    hiddenDiv.innerHTML = `<input type="hidden" class="input engraving-font-hidden" name="properties[Engraving Font]" value="DC Script" >`;
    cartForm.appendChild(hiddenDiv);
  }

  // Sort carat options
  if (selElmnt.name === "options[Carat Weight]") {
    optionsArray = [...selElmnt.options].sort((a, b) => a.value - b.value);
  }

  selectWraps[i].appendChild(newDiv);

  /* Create a new DIV to contain the option list: */
  const listOption = document.createElement("DIV");
  listOption.setAttribute("class", "select-items select-hide swiper-wrapper");

  for (let j = 0; j < optionsArray.length; j++) {
    /* Create a new DIV to act as an option item: */
    const optionItem = document.createElement("DIV");
    optionItem.setAttribute("class", "swiper-slide ring-size-option");
    // Create an img element
    const img = document.createElement("IMG");
    // Extract the image URL from the option's text
    const optionText = optionsArray[j].text;
    const imgSrcMatch = optionText.match(/\/\/[^ ]+/); // Extract URL starting with `//`
    if (imgSrcMatch) {
      img.src = imgSrcMatch[0]; // Assign extracted URL
    } else {
      img.src = ''; // Fallback if no URL is found
    }
    img.loading = "lazy";
    optionItem.appendChild(img);

    optionItem.innerHTML += optionsArray[j].innerHTML;  // Keep the original text
    optionItem.style.fontFamily = optionsArray[j].style.fontFamily;
    if (optionsArray[j].style.fontSize) {
      optionItem.style.fontSize = optionsArray[j].style.fontSize;
    }
    optionItem.dataset.value = optionsArray[j].value;
    optionItem.dataset.fontSize = optionsArray[j].dataset.fontSize;

    // Set selected item class
    if (selElmnt.value === optionsArray[j].value) {
      optionItem.setAttribute("class", "same-as-selected swiper-slide");
    }

    optionItem.addEventListener("click",function(e) {
      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.parentNode.previousSibling;
      
      // Prevent the slider from shifting when clicking
      e.preventDefault();
      e.stopPropagation();
    
      for (i = 0; i < sl; i++) {
        if (s.options[i].value == s.value) {
          s.selectedIndex = i;
          if (s.options[i].value === this.dataset.value) {
            s.options[i].setAttribute("selected", "selected");
          } else {
            s.options[i].removeAttribute("selected");
          }
    
          if (selElmnt.id !== "engraving_font") {
            h.innerHTML = this.innerHTML;
          }
          if (
            selElmnt.id === "engraving_font" &&
            document.querySelector(".engraving-font-hidden")
          ) {
            document.querySelector(".engraving-font-hidden").value = this.dataset.value;
          }
          if (selElmnt.id === "engraving_font") {
            document.querySelector(".engraving-input").style.fontFamily = this.style.fontFamily;
            if (this.dataset.value === "Caramel") {
              document.querySelector(".engraving-input").style.fontSize = "1.2em";
            } else {
              document.querySelector(".engraving-input").style.fontSize = this.dataset.fontSize;
            }
          }
          // Set event listener on ring size and engraving
          if (selElmnt.id === "ring_size") {
            document.querySelector(".ring-size-hidden").value = this.dataset.value;
          }
          if (selElmnt.name === "options[Metal]") {
            //const colorMetafield = document.querySelector(".metal_color")
           // colorMetafield.innerHTML = this.innerHTML
          }
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
    
      // Commenting out the h.click() if it causes the slider shift.
      // h.click();
    
      s.value = this.dataset.value;
      var event = new Event("change");
      s.dispatchEvent(event);
      
      let newPrice = document.querySelector('.product-price-varit span[data-price]').innerText.replace(',', '').replace(' ', '').replace('R', '');
      reloadPayflexWidget(newPrice);

    });
    
    listOption.appendChild(optionItem);
  }

  const listOptionParentWrapper = document.createElement("DIV");

  if(selElmnt.name === "options[Metal]"){ 
    listOptionParentWrapper.setAttribute("class", "swiper-container-parent-wrapper-metal");
  } else if(selElmnt.name === "options[Carat Weight]"){
    listOptionParentWrapper.setAttribute("class", "swiper-container-parent-wrapper-carat");
  } else  if(selElmnt.id === "ring_size"){
    listOptionParentWrapper.setAttribute("class", "swiper-container-parent-wrapper-ring");
  } else {

  }

  listOptionParentWrapper.appendChild(listOption);

  //append div inside pareent wrapper
  if(selElmnt.name === "options[Metal]"){
    const swiperButtonNext = document.createElement("DIV");
    swiperButtonNext.setAttribute("class", "swiper-button-next");
    listOptionParentWrapper.appendChild(swiperButtonNext);
    const swiperButtonPrev = document.createElement("DIV");
    swiperButtonPrev.setAttribute("class", "swiper-button-prev");
    listOptionParentWrapper.appendChild(swiperButtonPrev);
  } else if (selElmnt.name === "options[Carat Weight]") {
    const swiperButtonNext = document.createElement("DIV");
    swiperButtonNext.setAttribute("class", "swiper-button-next");
    listOptionParentWrapper.appendChild(swiperButtonNext);
    const swiperButtonPrev = document.createElement("DIV");
    swiperButtonPrev.setAttribute("class", "swiper-button-prev");
    listOptionParentWrapper.appendChild(swiperButtonPrev);
  } else if (selElmnt.id === "ring_size") {  
    const swiperButtonNext = document.createElement("DIV");
    swiperButtonNext.setAttribute("class", "swiper-button-next");
    listOptionParentWrapper.appendChild(swiperButtonNext);
    const swiperButtonPrev = document.createElement("DIV");
    swiperButtonPrev.setAttribute("class", "swiper-button-prev");
    listOptionParentWrapper.appendChild(swiperButtonPrev);
  } else {
  }

  selectWraps[i].appendChild(listOptionParentWrapper);
  newDiv.addEventListener("click", function (e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

// Add onchange to custom inputs
const engravingInput = document.querySelector(".engraving-input");

document.addEventListener("product:variant-change", (e) => {
  const thisVariant = e.detail.variant;
  const srcElement = e.detail.srcElement;

  window["productOptions"].forEach((item) => {
    if (item.variantId.toString() === thisVariant.id.toString()) {
      // Get metafields to update 
      if (item.variantMetafields) {
        item.variantMetafields.forEach(metafield => {
          const domElem = document.querySelector(`.${metafield.key}`)
          if (domElem) {
            domElem.innerHTML = metafield.value
          }
        })
      }
      document.querySelector('.product-image').src = item.variantImg
      // document.querySelector('.affirm-as-low-as').dataset.amount = item.variantPrice.replaceAll("$", "").replaceAll(",", "") + "00"
      // affirm.ui.refresh();
    }
    if (item.variantId.toString() === thisVariant.id.toString() && srcElement.name === "options[Metal]") {
      const selectedColor = item.variantColor 
      productCanvas.contentWindow.postMessage({ "metalColor": selectedColor }, "https://d2eqyk8w4pgmvx.cloudfront.net/index.html");
    }
    if (item.variantId.toString() === thisVariant.id.toString() && srcElement.name === "options[Carat Weight]") {
      const postData = { "importUrl": item.variantModel }
      productCanvas.contentWindow.postMessage(postData, "https://d2eqyk8w4pgmvx.cloudfront.net/index.html");
    }
  });
});

// Buy Now Button Validation
window.addEventListener('load', () => {
  function fixBuyNow() {
    const buyButton = document.querySelector('[data-testid="Checkout-button"]') || document.querySelector('[data-testid="sheet-open-button"]');
    if (!buyButton) {
      setTimeout(fixBuyNow, 10)
      return
    }
    let originalButton = buyButton
    const newButton = document.createElement('div')
    newButton.innerHTML = "<span style='font-weight: 700!important;'>Buy Now</span>"
    newButton.setAttribute("class", "btn btn--medium btn--full btn--primary buy-now-button")
    newButton.setAttribute("style", "flex-basis: 50%;")
    document.querySelector('[data-shopify="payment-button"]')?.replaceWith(newButton)

    const quantityError = document.querySelector('.quantity-error');
    document.querySelector('.buy-now-button').addEventListener("click", () => {
      const ringSize = document.querySelector(".ring-size-hidden")?.value;
      if (ringSize === "" || ringSize === "--") {
        quantityError.innerText = "Please select a Ring Size!";
        quantityError.style.display = "block";
      } else {
        buyButton?.replaceWith(originalButton);
        buyButton?.click();
      }
    })
  }
  fixBuyNow()
});

var swiperMetalWrapper = new Swiper('.swiper-container-parent-wrapper-metal', {
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
var swiperMetalWrapper = new Swiper('.swiper-container-parent-wrapper-carat', {
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
var swiperRingWrapper = new Swiper('.swiper-container-parent-wrapper-ring', {
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


document.querySelectorAll('#ring_size .ring-size-option').forEach(function(element) {
  element.addEventListener('click', function() { 
    console.log('clicked');
      document.querySelector('.shopify-payment-button__button.shopify-payment-button__button--unbranded').style.pointerEvents = "none";
  });
});


